import React, { useEffect } from 'react';
import { get } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { Selector } from 'shared/components';
import { setActiveCustomerAccount } from 'redux/account/actions';
import { fetchCustomerAccounts } from '../actions';
import './styles.scss';
import { useTranslation } from 'react-i18next';

const CustomerAccountSelector = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const activeAccountId = useSelector((state) =>
    get(state, 'account.activeAccountId'),
  );
  const customerAccounts = useSelector((state) =>
    get(state, 'account.customerAccounts', []),
  );
  const loading = useSelector((state) => get(state, 'account.loading'));
  const accountsError = useSelector((state) => get(state, 'account.error'));
  const accountsFetched = useSelector((state) =>
    get(state, 'account.fetched', false),
  );

  useEffect(() => {
    if (
      !loading &&
      !accountsError &&
      customerAccounts.length === 0 &&
      !accountsFetched
    ) {
      dispatch(fetchCustomerAccounts());
    }
  }, [
    dispatch,
    loading,
    accountsError,
    customerAccounts.length,
    accountsFetched,
  ]);

  const customStyles = {
    option: (provided) => ({
      ...provided,
      backgroundColor: 'transparent',
      cursor: 'pointer',
      outline: 'none',
    }),
    control: (provided) => ({ ...provided, outline: 'none' }),
    singleValue: (provided, state) => ({
      ...provided,
      opacity: state.isDisabled ? 0.8 : 1,
      transition: 'opacity(300ms)',
      cursor: 'pointer',
      outline: 'none',
    }),
  };

  const handleCompanyChange = (companyId) => {
    dispatch(setActiveCustomerAccount(companyId || null));
  };

  return (
    <div className="CompanySelector">
      <Selector
        options={customerAccounts}
        getOptionLabel={(o) => o.name}
        getOptionValue={(o) => o.id}
        value={activeAccountId}
        className="company-selector"
        classNamePrefix="company-selector-inner"
        disabled={loading}
        styles={customStyles}
        handleChange={handleCompanyChange}
        placeholder={t('Select customer account')}
        labelKey="name"
        valueKey="id"
        isClearable
        isLoading={loading}
      />
    </div>
  );
};

export default CustomerAccountSelector;
